<template></template>

<script>
export default {
  name: "Solver",
  mounted() {
    if (this.$route.params) {
      this.$router.push({
        name: "feeds",
        params: { tag: this.$route.params.tag },
      });
    }
  },
};
</script>

<style scoped>
</style>